import cn from 'classnames'
import React from 'react'

import styles from './IntegrationCase.module.scss'

import { List, ListItem } from '~lib/ui-kit/List'
import Button from '~shared/ui/Button'
import Flex from '~shared/ui/Flex'
import Text from '~shared/ui/Text'

interface IntegrationCaseProps extends React.HTMLAttributes<HTMLDivElement> {
  icon: React.ReactNode
  title: string
  description: string
  aspects: string[]
  value?: string
  active?: boolean
  configured?: boolean
  readOnly?: boolean
  onActionClick?: (value: string) => void
}

function IntegrationCase({
  value,
  icon,
  title,
  description,
  aspects,
  active,
  configured = active,
  readOnly,
  className,
  onActionClick,
  ...props
}: IntegrationCaseProps) {
  const handleActionClick = () => {
    onActionClick(value)
  }

  return (
    <div className={cn(styles.root, active && styles.active, className)} {...props}>
      <div className={styles.content}>
        <Flex align="center" justify="start" gap="1" className="mb-1">
          <Flex align="center" justify="center">
            {icon}
          </Flex>

          <Text as="h3" variant="default" textType="heading-sm">
            {title}
          </Text>

          {active && (
            <Text as="span" variant="success" textType="body-md">
              Active
            </Text>
          )}
        </Flex>

        <Text variant="secondary" textType="body-md" className="mb-3">
          {description}
        </Text>

        <List type="disc" variant="secondary" className="pl-2">
          {aspects.map((aspect) => {
            return <ListItem key={aspect}>{aspect}</ListItem>
          })}
        </List>
      </div>

      {!readOnly && (
        <div className={styles.aside}>
          <Button variant={configured ? 'default' : 'primary'} className={styles.actionBtn} onClick={handleActionClick}>
            {configured ? 'Edit' : 'Configure'}
          </Button>
        </div>
      )}
    </div>
  )
}

export default IntegrationCase
